export default {
  levelInfo: '等级信息',
  levelName: '等级名称',
  levelCode: '等级编码',
  levelSort: '排序',
  minExp: '所需成长值',
  status: '状态',
  defaultFlag: '默认入会等级',
  guestDefaultFlag: '默认游客转会等级',
  updateTime: '更新时间',
  description: '等级说明',
  addLevel: '添加等级',
  editLevel: '编辑等级',
  levelSortDesc: '数字越大等级越高',
  statusEnable: '启用',
  statusDisable: '停用',
  defaultFlagEnable: '是',
  defaultFlagDisable: '否',
  updateStatus: '修改状态',

  card: {
    cardNo: '实体卡号',
    nickname: '会员名称',
    mobile: '手机号',
    channel: '注册方式',
    status: '状态',
    registerShopName: '注册门店',
    createTime: '创建时间',
    lastUseTime: '最后使用时间',
    statusNormal: '正常',
    statusFrozen: '冻结',
    statusDisabled: '冻结',
    statusReplace: '已解绑',
    statusUnbind: '已解绑',
    WECHAT_MP: '微信小程序',
    WECHAT_OA: '微信公众号',
    OFFLINE: '线下门店',
    POS: 'POS收银',
    ADMIN: '管理后台',
    API: '开放API',
    assetName: '资产名称',
    amount: '数量',
    latestChange: '最近变动',
    bizVoucherNo: '业务凭证号',
    remainTimes: '剩余次数',
    orderNo: '订单号',
    orderType: '订单类型',
    shopName: '扣费门店',
    time: '时间',
    playTime: '游玩时间',
    projectName: '项目名称',
    verifyAsset: '核销资产',
    operatorName: '操作人',
    operationTime: '操作时间',
    operateShopName: '操作门店',
    changeTime: '变更时间',
    changeShopName: '变更门店',
    changerName: '变更人',
    changeType: '变更类型',
    changeContent: '变更内容',
    operationType: '操作类型',
    operationContent: '操作内容',
    source: '来源',
    content: '内容',
    basic: '基础资料',
    card: '会员卡',
    asset: '会员资产',
    orders: '消费订单',
    play: '游玩记录',
    log: '操作日志',
    detail: '会员详情',
    edit: '编辑资料',
    freeze: '冻结会员',
    lastConsume: '最近消费',
    countTicket: '计次票张数',
    lastVisit: '最近到店',
    timeTicket: '年月票数',
    consumeData: '消费数据',
    times: '次',
    memberNo: '用户编号',
    realCardNo: '实体卡号',
    levelName: '会员等级',
    gender: '性别',
    male: '男',
    female: '女',
    unknown: '未知',
    birthday: '生日',
    registerTime: '注册时间',
    remark: '备注',
  },
  asset: {
    member: '会员',
    userNo: '用户编号',
    nickname: '会员昵称',
    mobile: '手机号',
    shop: '发生门店',
    assetType: '资产类型',
    assetName: '资产名称',
    changeType: '变更类型',
    beforeAvailableAmount: '变动前值',
    afterAvailableAmount: '变动后值',
    amountChangeType: '数量变动类型',
    bizVoucherNo: '关联单据',
    clientType: '来源',
    createByName: '操作人',
    createTime: '流水时间',
    assetTypeBalance: '储值余额',
    assetTypeGiftAmount: '赠金',
    assetTypeGameCoin: '游戏币',
    assetTypeLotteryTicket: '彩票',
    assetTypeGiftCoin: '赠币',
    assetTypePoints: '积分',
    assetTypeCountTicket: '计次票',
    assetTypeMonthYearTicket: '年月票',
    assetTypeCoupon: '优惠券',
    allAssetTypes: '全部资产类型',
    productName: '商品名称',
    productType: '商品类型',
    ticketStatus: '门票状态',
    totalCount: '总次数',
    remainingCount: '剩余次数',
    acquiredTime: '获得时间',
    effectiveTime: '生效时间',
    expireTime: '到期时间',
    activationMethod: '激活方式',
    statusAvailable: '可使用',
    statusUsedUp: '已用完',
    statusExpired: '已过期',
    effectBuyAfter: '购买后立即生效',
    effectFirstUse: '第一次使用后开始生效',
    effectDaysAfter: '购买后指定时间生效',
    effectCustom: '自定义时间生效',
    changeTypePurchase: '购买',
    changeTypeAssetPay: '资产支付',
    changeTypeVerify: '核销',
    changeTypeImport: '导入',
    changeTypeRefund: '退款',
    changeTypeCancel: '撤销',
    changeTypeExpired: '过期',
    changeTypeManualAdjust: '手工调整',
    changeTypeGift: '赠送',
    clientTypeAdmin: '管理后台',
    clientTypeCashier: '收银台',
    unitTimes: '次',
    unitSheet: '张',
  },
  order: {
    purchaseTime: '购买时间',
    consumeShop: '消费门店',
    orderAmount: '订单金额',
    discountAmount: '优惠金额',
    paidAmount: '实收金额',
    salesChannel: '售卖渠道',
    viewDetails: '查看详情',
  },
  tourist: {
    guestNo: '用户编号',
    cardNo: '实体卡号',
    mediumType: '识别介质',
    mediumTypeName: '识别介质名称',
    mobile: '手机号',
    nickname: '昵称',
    status: '状态',
    statusName: '状态名称',
    registerShopId: '注册门店ID',
    registerShopName: '注册门店',
    totalConsumeCount: '累计消费次数',
    totalConsumeAmount: '累计消费金额',
    countTicketCount: '计次票张数',
    timeTicketCount: '年月票张数',
    lastConsumeTime: '最近消费',
    lastVisitTime: '最近到访',
    statusNormal: '正常',
    statusDisabled: '禁用',
    mediumTypeMember: '会员卡',
    mediumTypePhysical: '实体卡',
    operation: '操作',
    viewInfo: '查看信息',
    upgradeMember: '转会员',
    upgradeTip: '游客转会员后，系统生成新的会员号；原游客号仅用于历史追溯，不再出现在游客主列表。',
    guestInfo: '游客信息',
    memberInfo: '会员信息',
    levelId: '会员等级',
    selectLevel: '请选择会员等级',
    remark: '转会员说明',
    cancel: '取消',
    confirmUpgrade: '确认转会员',
    mobileRequired: '请输入手机号',
    mobileFormat: '请输入正确的手机号格式',
    nicknameRequired: '请输入昵称/姓名',
    nicknameLength: '昵称/姓名长度不能超过50个字符',
    levelRequired: '请选择会员等级',
    upgradeSuccess: '转会员成功',
    upgradeFailed: '转会员失败',
  },
  profile: {
    userId: '会员ID',
    memberNo: '用户编号',
    tier: '会员层级',
    tierName: '会员层级名称',
    genderName: '性别名称',
    levelName: '会员等级',
    levelCode: '等级编码',
    channelName: '注册方式名称',
    lastConsumeTime: '最近消费',
    lastVisitTime: '最近到访',
    totalConsumeCount: '累计消费次数',
    totalConsumeAmount: '累计消费金额',
    countTicketCount: '计次票张数',
    timeTicketCount: '年月票张数',
    createTime: '注册时间',
    male: '男',
    female: '女',
    operation: '操作',
    detail: '详情',
    edit: '编辑',
    memberTag: '会员标签',
    memberTagGold: '金子会员',
    memberTagConsumer: '消费者',
    memberTagNew: '新会员',
    status: '状态',
    statusNormal: '正常',
    statusFrozen: '冻结',
    statusCancelled: '注销',
    editMember: '编辑会员',
    editableInfo: '可编辑信息',
    uneditableInfo: '不可编辑信息',
    editTip: '(注：仅允许维护会员基础资料；注册门店、注册方式、实体卡号、创建时间为系统生成或业务来源字段，本期不可编辑。)',
    selectLevel: '请选择会员等级',
    editSuccess: '编辑成功',
    mobileRequired: '请输入手机号',
    mobileFormat: '请输入正确的手机号格式',
    nicknameRequired: '请输入昵称/姓名',
    nicknameLength: '昵称/姓名长度不能超过50个字符',
    levelRequired: '请选择会员等级',
    genderRequired: '请选择性别',
    freeze: '冻结',
    unfreeze: '解冻',
    freezeMember: '冻结会员',
    unfreezeMember: '解冻会员',
    statusOperation: '状态操作信息',
    currentMember: '当前会员',
    targetOperation: '目标操作',
    operationReason: '操作原因',
    reasonPlaceholder: '请输入操作原因，最多100字',
    reasonRequired: '请输入操作原因',
    reasonLength: '操作原因不能超过100个字符',
    freezeTip: '会员状态通过状态冻结/解冻操作改变；资料编辑冻结后不可直接修改状态，冻结/解冻时必须填写操作原因，并写入操作日志。',
    unfreezeTip: '会员状态通过状态冻结/解冻操作改变；资料编辑冻结后不可直接修改状态，冻结/解冻时必须填写操作原因，并写入操作日志。',
    freezeSuccess: '冻结成功',
    unfreezeSuccess: '解冻成功',
  },
};
